<template>
  <div class="application--footer application--footer-fixed">
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Manage Products</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()" class="white--text">
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-menu bottom left>
        <v-btn icon slot="activator" class="white--text">
          <v-icon>{{ listFormat.icon }}</v-icon>
          <v-icon small>expand_more</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, i) in listFormatMenuItems" :key="'menu' + i" @click="clickFormatMenu(item)">
            <v-list-tile-title><v-icon>{{ item.icon }}</v-icon></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text hidden-sm-and-up">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      class="hidden-sm-and-up"
    >
      <v-container grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="search"
              label="Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <category-dropdown v-model="categoryId" blank></category-dropdown>
            <!--<v-select
              :items="categories"
              item-text="name"
              item-value="categoryId"
              label="Category"
              v-model="categoryId"
            ></v-select>-->
          </v-flex>
          <v-flex xs12>
            <v-select
              :items="statuses"
              item-text="caption"
              item-value="value"
              label="Status"
              v-model="status"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
              :items="markups"
              item-text="name"
              item-value="productMarkupId"
              label="Markup"
              v-model="productMarkupId"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
              :items="suppliers"
              item-text="name"
              item-value="supplierId"
              label="Supplier"
              v-model="supplierId"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="sort"
              :items="sorts"
              item-text="caption"
              item-value="value"
              label="Sorting"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-btn
              block
              :disabled="!frmValid"
              @click="refreshList(); rightDrawer=false;"
            >
              Filter
            </v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn block @click="clearFilter(); rightDrawer = false;">Reset</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-container fluid grid-list-lg hidden-xs-only>
        <v-layout row wrap>
          <v-flex sm2>
            <v-text-field
              label="Search for"
              v-model="search"
              @keyup.enter="costPriceMin=''; costPriceMax=''; refreshList();"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <category-dropdown v-model="categoryId" blank></category-dropdown>
          </v-flex>
          <v-flex sm1>
            <v-select
              :items="statuses"
              item-text="caption"
              item-value="value"
              label="Status"
              v-model="status"
            ></v-select>
          </v-flex>
          <v-flex sm2>
            <v-select
              :items="markups"
              item-text="name"
              item-value="productMarkupId"
              label="Markup"
              v-model="productMarkupId"
            ></v-select>
          </v-flex>
          <v-flex sm1>
            <v-select
              :items="suppliers"
              item-text="name"
              item-value="supplierId"
              label="Supplier"
              v-model="supplierId"
            ></v-select>
          </v-flex>
          <v-flex sm1>
            <v-select
              v-model="sort"
              :items="sorts"
              item-text="caption"
              item-value="value"
              label="Sorting"
            ></v-select>
          </v-flex>
          <v-flex sm1>
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn
                  icon
                  @click="costPriceMin=''; costPriceMax=''; refreshList();"
                >
                  <v-icon>search</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs6>
                <v-btn
                  icon
                  @click="costPriceMin=''; costPriceMax=''; exportProducts();"
                >
                  <v-icon>get_app</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card>
        <v-container fluid grid-list-md v-if="listFormat.value === 'grid'">
          <v-layout row wrap>
            <v-flex
              v-for="item in items"
              md3
              xs6
              :key="item.productId"
            >
              <v-card flat>
                <v-checkbox
                  class="mt-0 mb-0"
                  color="primary"
                  v-model="item.chk"
                  label=""
                ></v-checkbox>
                <router-link :to="'/product/' + item.productId">
                  <v-img v-if="item.images.length > 0" :src="item.images[0].smallUrl" aspect-ratio="1.2"></v-img>
                  <div v-else style="width:100%; height: 150px; border: 1px solid #333333; padding: 20px 10px; text-align: center;">No Image</div>
                  <div v-if="item.shippingSubsidies && item.shippingSubsidies.freeShipping && item.shippingSubsidies.freeShipping.isFreeShipping === '1'" style="position:absolute;top:25px;left:25px;"><img src="/static/img/free-shipping.png" style="width:65px;height:auto;" /></div>
                </router-link>
                <v-card-actions :href="'/product/' + item.productId">
                  <v-container fluid grid-list-md fill-height pa-1>
                    <v-layout>
                      <v-flex xs12 align-end flexbox>
                        <router-link :to="'/product/' + item.productId">
                          <div class="body-2" v-text="item.name"></div>
                        </router-link>
                        <div class="subheading font-weight-bold">{{ item.currencySign }}{{ formatPrice(item.retailPrice) }}</div>
                        <div class="caption grey--text" v-for="sku in item.skus" :key="sku.sku">
                          <span :class="highlightSku(sku.costPrice)">
                            {{ sku.skuDisplay }}: <span :class="(sku.qty <= 0 ? 'red--text' : 'green--text') + ' font-weight-bold'">{{ sku.qty }}pcs</span><span v-if="sku.costPrice > 0">, cost: <strong>{{ item.currencySign }}{{ formatPrice(sku.costPrice) }} -> {{ item.currencySign }}{{ formatPrice(sku.retailPrice) }}</strong></span><span v-else>, price: <strong>{{ item.currencySign }}{{ formatPrice(sku.retailPrice) }}</strong></span>
                          </span>
                        </div>
                        <div v-if="item.productMarkupName" class="caption font-weight-light">Markup: <span class="font-weight-bold">{{ item.productMarkupName }}</span></div>
                        <div v-if="item.supplierName" class="caption font-weight-light">Supplier: <span class="font-weight-bold">{{ item.supplierName }}</span></div>
                        <div v-if="item.weight > 0" class="caption font-weight-light">Weight: {{ formatPrice(item.weight) }}kg</div>
                        <div v-else class="caption font-weight-light pt-2 pb-2"><span class="white--text orange pa-1">VIRTUAL ITEM</span></div>
                        <div v-if="item.params.length > 0" class="caption font-weight-light pt-2 pb-2"><span class="white--text blue lighten-1 pa-1">PARAMS</span></div>
                        <div v-if="item.status === 'disabled'" class="caption font-weight-light pt-2 pb-2"><span class="white--text grey pa-1">{{ item.status | allCaps }}</span></div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex
              v-if="items.length <= 0"
              xs12
              justify-center
              align-center
              text-xs-center
            >
              <v-icon x-large color="primary">error_outline</v-icon>
              <div>
                No products yet
              </div>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container fluid grid-list-md v-else-if="listFormat.value === 'list'">
          <v-layout row wrap>
            <v-flex xs12 v-if="items.length > 0">
              <table border="0" cellspacing="0">
                <tr style="height:50px;">
                  <th width="5%"></th>
                  <th width="20%" colspan="2">Product</th>
                  <th width="20%" align="center">Variant & SKU</th>
                  <th width="9%" align="center">Cost</th>
                  <th width="9%" align="center">Price</th>
                  <th width="9%" align="center">Weight</th>
                  <th width="9%" align="center">Stock</th>
                  <th width="10%" align="center">Markup</th>
                  <th width="9%" align="center">Status</th>
                </tr>
                <tr>
                  <td colspan="10" style="height:30px;border-top:1px solid #aaaaaa">
                  </td>
                </tr>
                <tr v-for="item in items" :key="item.productId">
                  <td valign="top">
                    <v-checkbox
                      class="mt-0 mb-0"
                      color="primary"
                      v-model="item.chk"
                      label=""
                    ></v-checkbox>
                  </td>
                  <td valign="top" class="pb-4">
                    <router-link :to="'/product/' + item.productId">
                      <img v-if="item.images.length > 0" :src="item.images[0].smallUrl" style="width:60px;border:1px solid #bcbcbc;">
                      <div v-else style="width:100%; height: 150px; border: 1px solid #333333; padding: 20px 10px; text-align: center;">No Image</div>
                      <div v-if="item.shippingSubsidies && item.shippingSubsidies.freeShipping && item.shippingSubsidies.freeShipping.isFreeShipping === '1'" style="position:absolute;top:25px;left:25px;"><img src="/static/img/free-shipping.png" style="width:65px;height:auto;" /></div>
                    </router-link>
                  </td>
                  <td valign="top" class="pl-3 pt-0 pr-3 pb-4">
                    <router-link :to="'/product/' + item.productId">
                      <div class="body-2" v-text="item.name"></div>
                    </router-link>
                  </td>
                  <td valign="top" align="center" class="pb-4">
                    <div v-for="sku in item.skus" :key="sku.sku" class="list-table-row">
                      <div v-if="sku.skuDisplay !== 'SKU'" class="font-weight-bold">{{ sku.skuDisplay }}</div>
                      <div>{{ sku.sku }}</div>
                    </div>
                  </td>
                  <td valign="top" align="center">
                    <div v-for="sku in item.skus" :key="sku.sku" class="list-table-row">
                      <span class="mr-1">{{ item.currencySign }}</span>
                      <input type="text"
                        :disabled="item.productMarkupId === ''"
                        v-model="sku.costPriceUpdate"
                        @blur="(event) => setSkuCostPrice(event, sku)"
                        @keyup.enter="$event.target.blur()"
                        @focus="$event.target.select()"
                        :class="sku.costPriceUpdateCssClass"
                        :style="(item.productMarkupId === '' ? 'background-color:#efefef;' : 'background-color:#ffffff') + 'position:relative;top:-5px;border:1px solid #cccccc;text-align:center;width:60px;height:30px;'"
                      >
                    </div>
                  </td>
                  <td valign="top" align="center">
                    <div v-for="sku in item.skus" :key="sku.sku" class="list-table-row">
                      {{ item.currencySign }}{{ formatPrice(sku.retailPrice) }}
                    </div>
                  </td>
                  <td valign="top" align="center">
                    <div v-for="sku in item.skus" :key="sku.sku" class="list-table-row" style="display:flex;justify-content: center;">
                      <input type="text"
                        v-model="sku.weightUpdate"
                        @blur="(event) => setSkuWeight(event, sku)"
                        @keyup.enter="$event.target.blur()"
                        @focus="$event.target.select()"
                        :class="sku.weightUpdateCssClass"
                        style="position:relative;top:-5px;border:1px solid #cccccc;text-align:center;width:60px;height:30px;"
                      >
                      <span class="ml-2">kg</span>
                    </div>
                  </td>
                  <td valign="top" align="center">
                    <div v-for="sku in item.skus" :key="sku.sku" class="list-table-row">
                      <input type="text"
                        v-model="sku.qtyUpdate"
                        @blur="(event) => setSkuQty(event, sku)"
                        @keyup.enter="$event.target.blur()"
                        @focus="$event.target.select()"
                        :class="sku.qtyUpdateCssClass"
                        style="position:relative;top:-5px;border:1px solid #cccccc;text-align:center;width:60px;height:30px;"
                      >
                    </div>
                  </td>
                  <td valign="top" align="center">
                    {{ item.productMarkupName }}
                  </td>
                  <td valign="top" align="center" text-xs-center>
                    <div class="pl-1" style="width:45px;overflow:hidden;">
                      <v-switch
                        v-model="item.statusChk"
                        color="primary"
                        class="pa-0 ma-0"
                        @change="(event) => setProductStatus(event, item)"
                      ></v-switch>
                    </div>
                  </td>
                </tr>
              </table>
            </v-flex>
            <v-flex
              v-else
              xs12
              justify-center
              align-center
              text-xs-center
            >
              <v-icon x-large color="primary">error_outline</v-icon>
              <div>
                No products yet
              </div>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container>
          <v-layout>
            <v-flex xs12 class="mt-4">
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <v-footer app height="80" class="product-footer elevation-24">
        <v-container class="ma-0 pa-0 ml-2">
          <v-layout row wrap>
            <v-flex md3 hidden-xs-only>
            </v-flex>
            <v-flex md9 xs12>
              <v-container fluid grid-list-xs class="ma-0 pa-0">
                <v-layout row wrap>
                  <v-flex md2 xs4>
                    <v-checkbox
                      class="ml-1 mt-3"
                      color="primary"
                      label="Select all"
                      v-model="chkAllProducts"
                      @change="selectAllCheckboxes(chkAllProducts)"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md3 xs8>
                    <div class="mt-4">
                      Showing {{ items.length }} of {{ listTotal }} products
                    </div>
                  </v-flex>
                  <v-flex md1 hidden-xs-only>
                    <v-divider
                      class="mx-3"
                      vertical
                    ></v-divider>
                  </v-flex>
                  <v-flex md3 xs6>
                    <v-select
                      class="ml-1"
                      small
                      :items="bulkActions"
                      item-text="caption"
                      item-value="value"
                      label="Select action"
                      v-model="cboBulkAction"
                    ></v-select>
                  </v-flex>
                  <v-flex md3 xs6>
                    <v-btn
                      outline
                      class="ml-3 mt-3"
                      @click="doBulkAction"
                    >
                      Go
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex xs12>
            </v-flex>
          </v-layout>
        </v-container>
      </v-footer>
      <v-dialog v-model="markupDialog" max-width="300px">
        <v-card>
          <v-card-title>
            <h2>Set Markup</h2>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="frmMarkupValid" lazy-validation>
              <!-- <v-checkbox
                v-if="chkAllProducts && items.length < listTotal"
                color="primary"
                label="Also apply to products from next pages"
                v-model="chkSelectFromAllPages"
              ></v-checkbox> -->
              <v-select
                :items="markups"
                item-text="name"
                item-value="productMarkupId"
                :rules="[v => !!v || 'Please select markup']"
                label="Markup"
                v-model="cboSetMarkup"
                required
              ></v-select>
              <v-btn
                :disabled="!frmMarkupValid"
                @click="assignMarkupToProducts"
              >
                Set
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="supplierDialog" max-width="300px">
        <v-card>
          <v-card-title>
            <h2>Set Supplier</h2>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="frmSupplierValid" lazy-validation>
              <v-select
                :items="suppliers"
                item-text="name"
                item-value="supplierId"
                :rules="[v => !!v || 'Please select supplier']"
                label="Supplier"
                v-model="cboSetSupplier"
                required
              ></v-select>
              <v-btn
                :disabled="!frmSupplierValid"
                @click="assignSupplierToProducts"
              >
                Set
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="categoryDialog" max-width="300px" v-if="categoryDialog === true">
        <v-card>
          <v-card-title>
            <h2>Set Category</h2>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="frmCategoryValid" lazy-validation>
              <category-dropdown v-model="cboSetCategory" label="Category" :categoryArray="categories"></category-dropdown>
              <!--<v-select
                :items="categories"
                item-text="name"
                item-value="categoryId"
                :rules="[v => !!v || 'Please select category']"
                label="Category"
                v-model="cboSetCategory"
                required
              ></v-select>-->
              <category-dropdown v-model="cboSetSecondaryCategory" label="Secondary Category" :categoryArray="categories" blank></category-dropdown>
              <!--<v-select
                :items="categories"
                item-text="name"
                item-value="categoryId"
                label="Secondary Category"
                v-model="cboSetSecondaryCategory"
                required
              ></v-select>-->
              <v-btn
                :disabled="!frmCategoryValid"
                @click="assignCategoryToProducts"
              >
                Set
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          to="/product"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import { EventBus } from '../main'
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import CategoryDropdown from '@/components/CategoryDropdown.vue'
import axios from 'axios'
import router from '../router'
import downloadjs from 'downloadjs'

export default {
  components: {
    SideDrawer,
    CategoryDropdown,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      rightDrawer: false,
      loading: false,
      frmValid: true,
      listFormatMenuItems: [
        {
          icon: 'apps',
          value: 'grid'
        },
        {
          icon: 'list',
          value: 'list'
        }
      ],
      listFormat: {
        icon: 'apps',
        value: 'grid'
      },
      search: (this.$route.query.search ? this.$route.query.search : ''),
      categories: [],
      categoryId: (this.$route.query.categoryId ? this.$route.query.categoryId : ''),
      status: (this.$route.query.status ? this.$route.query.status : ''),
      statuses: [
        {
          caption: '-',
          value: ''
        },
        {
          caption: 'Active',
          value: 'active'
        },
        {
          caption: 'Disabled',
          value: 'disabled'
        }
      ],
      markups: [],
      productMarkupId: (this.$route.query.productMarkupId ? this.$route.query.productMarkupId : ''),
      suppliers: [],
      supplierId: (this.$route.query.supplierId ? this.$route.query.supplierId : ''),
      costPriceMin: (this.$route.query.costPriceMin ? this.$route.query.costPriceMin : ''),
      costPriceMax: (this.$route.query.costPriceMax ? this.$route.query.costPriceMax : ''),
      sort: (this.$route.query.sort ? this.$route.query.sort : ''),
      sorts: [
        {
          caption: 'Latest',
          value: 'createdDateTime:desc'
        },
        {
          caption: 'Updated',
          value: 'updatedDateTime:desc'
        },
        {
          caption: 'Lowest Price',
          value: 'retailPrice:asc'
        },
        {
          caption: 'Highest Price',
          value: 'retailPrice:desc'
        },
        {
          caption: 'Lowest Stock',
          value: 'totalQty:asc'
        },
        {
          caption: 'Highest Stock',
          value: 'totalQty:desc'
        }
      ],
      isLoadingItems: false,
      items: [],
      listLimit: 20,
      listOffset: 0,
      listTotal: 0,
      chkAllProducts: false,
      chkSelectFromAllPages: false,
      cboBulkAction: '',
      bulkActions: [
        {
          caption: 'Set Markup',
          value: 'markup'
        },
        {
          caption: 'Set Supplier',
          value: 'supplier'
        },
        {
          caption: 'Set Category',
          value: 'category'
        },
        {
          caption: 'Export CSV (Shopee)',
          value: 'csv-shopee'
        }
      ],
      markupDialog: false,
      frmMarkupValid: false,
      cboSetMarkup: '',
      supplierDialog: false,
      frmSupplierValid: false,
      cboSetSupplier: '',
      categoryDialog: false,
      frmCategoryValid: false,
      cboSetCategory: '',
      cboSetSecondaryCategory: ''
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.refreshList()

    var _this = this
    setTimeout(function () {
      if (_this.categories === undefined || _this.categories.length === 0) {
        _this.getCategories()
      }
    }, 3000)

    setTimeout(function () {
      _this.getMarkups()
      _this.getSuppliers()
    }, 5000)
  },

  created () {
    window.addEventListener('scroll', this.detectBottomOfWindow)
  },

  destroyed () {
    window.removeEventListener('scroll', this.detectBottomOfWindow)
  },

  methods: {
    clickFormatMenu: function (menuItem) {
      this.listFormat = menuItem
    },
    highlightSku: function (costPrice) {
      if (this.costPriceMin.length > 0 && this.costPriceMin > 0 && this.costPriceMax.length > 0 && this.costPriceMax > 0) {
        if (costPrice > this.costPriceMin && costPrice <= this.costPriceMax) {
          return 'yellow lighten-2 pa-0'
        }
      } else if (this.costPriceMin.length > 0 && this.costPriceMin > 0) {
        if (costPrice > this.costPriceMin) {
          return 'yellow lighten-2 pa-0'
        }
      } else if (this.costPriceMax.length > 0 && this.costPriceMax > 0) {
        if (costPrice <= this.costPriceMax) {
          return 'yellow lighten-2 pa-0'
        }
      }
      return ''
    },
    doBulkAction: function () {
      console.log('doBulkAction')
      this.chkSelectFromAllPages = false

      var isFound = false
      for (var i in this.items) {
        if (this.items[i].chk === true) {
          isFound = true
          break
        }
      }

      if (!isFound) {
        window.alert('Please select item first')
      }

      if (isFound) {
        if (this.cboBulkAction === 'markup') {
          this.markupDialog = true
        } else if (this.cboBulkAction === 'supplier') {
          this.supplierDialog = true
        } else if (this.cboBulkAction === 'category') {
          this.categoryDialog = true
        } else if (this.cboBulkAction === 'csv-shopee') {
          this.exportProducts(true, 'csv-shopee')
        } else {
          window.alert('Please select action')
        }
      }
    },
    setProductStatus: function (event, product) {
      const _this = this
      const promise = new Promise(function (resolve, reject) {
        _this.loading = true
        const newValue = (event === true ? 'active' : 'disabled')
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/product/' + product.productId, {
          status: newValue
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              product.status = newValue
            } else {
              window.alert(resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    setSkuCostPrice: function (event, skuData) {
      skuData.costPriceUpdate = event.target.value.trim()
      skuData.costPriceUpdateCssClass = ''
      if (!this.isFloat(Number(skuData.costPriceUpdate)) || skuData.costPriceUpdate === '') {
        skuData.costPriceUpdateCssClass = 'update-error'
        return false
      }

      const newValue = Number(skuData.costPriceUpdate)
      const originalValue = Number(skuData.costPrice)
      console.log('skuData', skuData)
      console.log('newValue', newValue)
      console.log('originalValue', originalValue)
      if (newValue !== originalValue) {
        const _this = this
        const promise = new Promise(function (resolve, reject) {
          _this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/product/sku/' + skuData.sku + '/cost', {
            costPrice: newValue
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                skuData.costPriceUpdateCssClass = 'update-success'
                skuData.costPrice = newValue
                skuData.costPriceInBase = resp.data.pricing.costPriceInBase
                skuData.retailPrice = resp.data.pricing.retailPrice
                skuData.retailPriceInBase = resp.data.pricing.retailPriceInBase
                for (let i in skuData.retailQtyPricing) {
                  skuData.retailQtyPricing[i].price = resp.data.pricing.retailQtyPricing[i].price
                  skuData.retailQtyPricing[i].priceInBase = resp.data.pricing.retailQtyPricing[i].priceInBase
                }
                skuData.wholesalePrice = resp.data.pricing.wholesalePrice
                skuData.wholesalePriceInBase = resp.data.pricing.wholesalePriceInBase
              } else {
                skuData.costPriceUpdateCssClass = 'update-error'
                window.alert(resp.data.message)
              }
              resolve()
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                  reject(error.response.status)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                  reject(error.response.status)
                }
                _this.loading = false
              }
            })
        })
        return promise
      }
    },
    setSkuWeight: function (event, skuData) {
      skuData.weightUpdate = event.target.value.trim()
      skuData.weightUpdateCssClass = ''
      if (!this.isFloat(Number(skuData.weightUpdate)) || skuData.weightUpdate === '') {
        skuData.weightUpdateCssClass = 'update-error'
        return false
      }

      const newValue = Number(skuData.weightUpdate)
      const originalValue = Number(skuData.weight)
      console.log('skuData', skuData)
      console.log('newValue', newValue)
      console.log('originalValue', originalValue)
      if (newValue !== originalValue) {
        const _this = this
        const promise = new Promise(function (resolve, reject) {
          _this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/product/sku/' + skuData.sku, {
            weight: newValue
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                skuData.weightUpdateCssClass = 'update-success'
                skuData.weight = newValue
              } else {
                skuData.weightUpdateCssClass = 'update-error'
                window.alert(resp.data.message)
              }
              resolve()
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                  reject(error.response.status)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                  reject(error.response.status)
                }
                _this.loading = false
              }
            })
        })
        return promise
      }
    },
    setSkuQty: function (event, skuData) {
      skuData.qtyUpdate = event.target.value.trim()
      skuData.qtyUpdateCssClass = ''
      if (!Number.isInteger(Number(skuData.qtyUpdate)) || skuData.qtyUpdate === '') {
        skuData.qtyUpdateCssClass = 'update-error'
        return false
      }

      const newValue = Number(skuData.qtyUpdate)
      const originalValue = Number(skuData.qty)
      console.log('skuData', skuData)
      console.log('newValue', newValue)
      console.log('originalValue', originalValue)
      if (newValue !== originalValue) {
        const _this = this
        const promise = new Promise(function (resolve, reject) {
          _this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/product/sku/' + skuData.sku, {
            qty: newValue
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                skuData.qtyUpdateCssClass = 'update-success'
                skuData.qty = newValue
              } else {
                skuData.qtyUpdateCssClass = 'update-error'
                window.alert(resp.data.message)
              }
              resolve()
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                  reject(error.response.status)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                  reject(error.response.status)
                }
                _this.loading = false
              }
            })
        })
        return promise
      }
    },
    assignMarkupToProducts: function () {
      var productIds = []
      for (var i in this.items) {
        if (this.items[i].chk === true) {
          productIds.push(this.items[i].productId)
        }
      }

      if (productIds.length > 0) {
        // assign markup to products
        var _this = this
        var promise = new Promise(function (resolve, reject) {
          _this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/product/markup/' + _this.cboSetMarkup + '/assign', {
            productIds: productIds
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                window.alert('Markup assigned to products')
                _this.markupDialog = false
                _this.refreshList()
              } else {
                window.alert(resp.data.message)
              }
              resolve()
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                  reject(error.response.status)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                  reject(error.response.status)
                }
                _this.loading = false
              }
            })
        })
        return promise
      } else {
        window.alert('Please select products')
      }
    },
    assignSupplierToProducts: function () {
      var productIds = []
      for (var i in this.items) {
        if (this.items[i].chk === true) {
          productIds.push(this.items[i].productId)
        }
      }

      if (productIds.length > 0) {
        // assign supplier to products
        var _this = this
        var promise = new Promise(function (resolve, reject) {
          _this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/supplier/' + _this.cboSetSupplier + '/assign', {
            productIds: productIds
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                window.alert('Supplier assigned to products')
                _this.supplierDialog = false
                _this.refreshList()
              } else {
                window.alert(resp.data.message)
              }
              resolve()
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                  reject(error.response.status)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                  reject(error.response.status)
                }
                _this.loading = false
              }
            })
        })
        return promise
      } else {
        window.alert('Please select products')
      }
    },
    assignCategoryToProducts: function () {
      var productIds = []
      for (var i in this.items) {
        if (this.items[i].chk === true) {
          productIds.push(this.items[i].productId)
        }
      }

      if (productIds.length > 0) {
        // assign category to products
        var _this = this
        var promise = new Promise(function (resolve, reject) {
          var secondaryCategories = null
          if (_this.cboSetSecondaryCategory) {
            secondaryCategories = [_this.cboSetSecondaryCategory]
          }
          _this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/category/assign', {
            categoryId: _this.cboSetCategory,
            secondaryCategoryIds: secondaryCategories,
            productIds: productIds
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                window.alert('Category assigned to products')
                _this.categoryDialog = false
                _this.refreshList()
              } else {
                window.alert(resp.data.message)
              }
              resolve()
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                  reject(error.response.status)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                  reject(error.response.status)
                }
                _this.loading = false
              }
            })
        })
        return promise
      } else {
        window.alert('Please select products')
      }
    },
    refreshList: function () {
      this.items = []
      this.getProducts(this.search, this.categoryId, this.status, this.productMarkupId, this.supplierId, this.costPriceMin, this.costPriceMax, this.sort, 0)
    },
    clearFilter () {
      this.search = ''
      this.categoryId = ''
      this.productMarkupId = ''
      this.supplierId = ''
      this.sort = ''
      this.refreshList()
    },
    selectAllCheckboxes: function (chkStatus) {
      for (var i in this.items) {
        this.items[i].chk = chkStatus
      }
    },
    detectBottomOfWindow: function (event) {
      // console.log(Math.ceil(document.documentElement.scrollTop + window.innerHeight))
      // console.log(document.documentElement.offsetHeight)
      let bottomOfWindow = Math.ceil(document.documentElement.scrollTop + window.innerHeight) >= (document.documentElement.offsetHeight - 5)

      if (bottomOfWindow) {
        if (this.listTotal > this.items.length) {
          this.getProducts(this.search, this.categoryId, this.status, this.productMarkupId, this.supplierId, this.costPriceMin, this.costPriceMax, this.sort, this.items.length)
        }
      }
    },
    getProducts: function (name = '', categoryId = '', status = '', productMarkupId = '', supplierId = '', costPriceMin = '', costPriceMax = '', sort = '', offset = 0) {
      var _this = this
      if (_this.isLoadingItems === false) {
        _this.isLoadingItems = true
        var promise = new Promise(function (resolve, reject) {
          _this.loading = true
          axios.get(process.env.VUE_APP_API_ROOT + '/v1/products?name=' + encodeURIComponent(name) + '&category_id=' + categoryId + '&status=' + status + '&product_markup_id=' + productMarkupId + '&supplier_id=' + supplierId + '&cost_price_min=' + costPriceMin + '&cost_price_max=' + costPriceMax + '&sort=' + sort + '&offset=' + offset + '&limit=' + _this.listLimit)
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                var regex = new RegExp('^SKU-[0-9A-Z]*-', 'g')
                var regex2 = new RegExp('^SKU-[0-9A-Z]*', 'g')
                for (var c = 0; c < resp.data.data.length; ++c) {
                  for (var d = 0; d < resp.data.data[c].skus.length; ++d) {
                    resp.data.data[c].skus[d].skuDisplay = resp.data.data[c].skus[d].sku.replace(regex, '')
                    resp.data.data[c].skus[d].skuDisplay = resp.data.data[c].skus[d].skuDisplay.replace(regex2, '')
                    if (resp.data.data[c].skus[d].skuDisplay.length <= 0) {
                      resp.data.data[c].skus[d].skuDisplay = 'SKU'
                    }

                    resp.data.data[c].skus[d].costPriceUpdate = resp.data.data[c].skus[d].costPrice
                    resp.data.data[c].skus[d].qtyUpdate = resp.data.data[c].skus[d].qty
                    resp.data.data[c].skus[d].weightUpdate = resp.data.data[c].skus[d].weight
                    resp.data.data[c].skus[d].costPriceUpdateCssClass = ''
                    resp.data.data[c].skus[d].qtyUpdateCssClass = ''
                    resp.data.data[c].skus[d].weightUpdateCssClass = ''
                  }
                  resp.data.data[c].statusChk = resp.data.data[c].status === 'active'
                }
                resp.data.data.chk = false
                _this.items = _this.items.concat(resp.data.data)
                _this.listLimit = resp.data.limit
                _this.listOffset = resp.data.offset
                _this.listTotal = resp.data.total

                // update query string
                _this.updateUrl('/products/?search=' + encodeURIComponent(_this.search) + '&categoryId=' + _this.categoryId + '&status=' + _this.status + '&productMarkupId=' + _this.productMarkupId + '&supplierId=' + _this.supplierId + '&costPriceMin=' + _this.costPriceMin + '&costPriceMax=' + _this.costPriceMax + '&sort=' + _this.sort)
              } else {
                console.log('unable to load products: ' + resp.data.message)
              }
              _this.isLoadingItems = false
              resolve()
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                  reject(error.response.status)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                  reject(error.response.status)
                }
                _this.isLoadingItems = false
                _this.loading = false
              }
            })
        })
        return promise
      }
    },
    exportProducts: function (isSelectedProductsOnly = false, format = 'csv-shopee') {
      console.log('exportProducts')
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true

        var productIds = []
        if (isSelectedProductsOnly === true) {
          for (var i in _this.items) {
            if (_this.items[i].chk === true) {
              productIds.push(_this.items[i].productId)
            }
          }
        }

        var filterJson = {
          name: encodeURIComponent(_this.search),
          categoryId: _this.categoryId,
          status: _this.status,
          productMarkupId: _this.productMarkupId,
          supplierId: _this.supplierId,
          costPriceMin: _this.costPriceMin,
          costPriceMax: _this.costPriceMax,
          productIds: productIds,
          sort: _this.sort,
          format: format
        }
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/products/export', filterJson, {
          responseType: 'blob'
        })
          .then(resp => {
            downloadjs(resp.data, 'products.csv', resp.headers['content-type'])
            _this.loading = false
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.isLoadingItems = false
              _this.loading = false
            }
          })
      })
      return promise
    },
    getCategories: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/categories')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            EventBus.$emit('categoryListLoaded', resp.data.data)
            this.categories = resp.data.data
          } else {
            console.log('unable to load categories: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    getMarkups: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/product/markups')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            var markups = [
              {
                name: '-',
                productMarkupId: ''
              }
            ]
            this.markups = markups.concat(resp.data.data)
          } else {
            console.log('unable to load markups: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    getSuppliers: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/suppliers')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            var suppliers = [
              {
                name: '-',
                supplierId: ''
              }
            ]
            this.suppliers = suppliers.concat(resp.data.data)
          } else {
            console.log('unable to load suppliers: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    generateCategoryListRecursive: function (inputCategories, output, level) {
      var strPad = ''
      for (var j = 0; j < level; j++) {
        strPad = strPad + '----'
      }
      for (var i = 0; i < inputCategories.length; i++) {
        inputCategories[i].level = level
        inputCategories[i].name = strPad + ' ' + inputCategories[i].name
        output.push(inputCategories[i])
        if (inputCategories[i].childs.length > 0) {
          output = this.generateCategoryListRecursive(inputCategories[i].childs, output, level + 1)
        }
      }
      return output
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

.update-error {
  border: 1px solid red !important;
}

.update-success {
  border: 1px solid rgb(0, 181, 0) !important;
}

.list-table-row {
  height: 60px;
}

@media screen and (max-width: 599px) {

  .product-footer {
    height: 140px !important;
  }
}
@media screen and (min-width: 960px) and (max-width: 1263px) {

}
@media screen and (min-width: 960px) and (max-width: 1263px) {

}

</style>
